module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_en-c14d3d192e28b2ada8af93c49a3d1feb.png";